/* eslint-disable no-underscore-dangle */
/**
 * This duplicates a number of environment variables from my-dot because we don't have access to them here.
 * In the future we should consider exporting these and deduplicating my-dot's versions of these.
 *
 * @see apps/my.patientrewardshub.com/src/javascript/config/environment.ts
 */
export const isClient = typeof window !== 'undefined';

/**
 * Are we rendering in Kohana?
 */
export const isLegacyServer =
  isClient &&
  // @ts-ignore
  window.phpJs;

/**
 * Are we rendering in Next.js?
 */
export const isNextServer = !isLegacyServer;
